import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[timeMask]'
})
export class TimeMaskDirective {

  @Output() timeChange = new EventEmitter<number>();

  constructor(private el: ElementRef) { }

  value: string;

  @HostListener('input', ['$event']) onInputChange(event) {
    const regex = /^[0-9:AMP]+$/g;
    const initalValue = this.el.nativeElement.value;
    this.el.nativeElement.value = initalValue.replace(/[^0-9-]*/g, '');
    if (regex.test(initalValue) || initalValue === '') {
      this.timeChange.emit(event);
    }
  }
}